<template>
  <div>
    <div class="white-section">
      <b-form @submit.prevent class="mt-0">
        <b-col md="4">
          <b-form-group
              :label="$t('unit.unitTitle')"
              label-for="unit-title"
              :invalid-feedback="invalidFeedbackTitle
              ? $t(`validation.${invalidFeedbackTitle}`, {
                  field: $t('section.sectionTitle'),
                })
              : ''
          "
          >
            <b-form-input autofocus
                id="unit-title" placeholder="عنوان واحد جدید را وارد کنید"
                :state="$v.title.$dirty ? !$v.title.$invalid : null"
                v-model="title"
                v-on:keyup.enter="onEnter"

            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group :label="$t('section.section')" label-for="unit-status" >
            <b-form-select
                text-field="title"
                value-field="_id"
                v-model="section"
                :options="sections"
                id="unit-status"
            />
          </b-form-group>
        </b-col>

      </b-form>
    </div>

    <div class="white-section mt-2">
      <b-row>
        <div class="col-12 text-right">
          <b-button
              size=""
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="info"
              class=""
              @click="addUnit"
          >
            {{ $t("general.submit") }}
          </b-button>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import Ripple from "vue-ripple-directive";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormSelect,
  BFormInvalidFeedback,
  BBreadcrumb,
} from "bootstrap-vue";

export default {

  data() {
    return {
      items: [
        {
          text: this.$t('unit.units'),
          to: {name: "manageUnit"}
        },
        {
          text: this.$t('unit.addUnit'),
          active: true
        }
      ],
      createAutomaticRecallNumber:true
    }
  },
  created() {
    this.$store.dispatch('sections/searchSection',{status:"active"}).then(() => {
        this.section = this.sections[0]._id
    })
    this.pushBreadcrumb({text: 'addUnit', to:{name:'addUnit' }, translate:true})
    this.setCurrentBreadcrumb([{text: 'addUnit', to:{name:'addUnit' }, translate:true}])
  },
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BFormInvalidFeedback,
    BBreadcrumb,
  },
  validations() {
    return {
      title: {
        required,
      }
    };
  },
  computed: {
    invalidFeedbackTitle: {
      set(error) {
      },
      get() {
        let error = "";
        if (!this.$v.title.$dirty) return error;
        if (!this.$v.title.required) error = "required";
        return error;
      },
    },
    ...mapGetters({
        sections : 'sections/sections'
    }),
    title: {
      set(title) {
        this.$store.commit("units/SET_TITLE", title);
      },
      get() {
        return this.$store.getters["units/title"];
      },
    },
    section: {
      set(section) {
        this.$store.commit("units/SET_SECTION", section);
      },
      get() {
        return this.$store.getters["units/section"];
      },
    },

  },
  methods: {
    onEnter(){
      this.addUnit()
    },
    addUnit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

          const payload = {
            title: this.title,
            status : 'active',
            // createAutomaticRecallNumber : this.createAutomaticRecallNumber,
            sectionId : this.section
          };
        this.$store.commit('SET_IS_LOADING', true)
          this.$store
            .dispatch("units/addUnit", payload)
            .then((response) => {
              this.$store.commit('SET_IS_LOADING', false)
              this.$bvToast.toast(this.$t('toastification.submissionSucceed'), {
                // title: this.$t('toastification.success'),
                variant: 'success',
                solid: true,
              });
              this.title = '';
              this.$router.push({name: "manageUnit"});
            })
            .catch((error) => {
              this.$bvToast.toast(this.$t('toastification.submissionFailed'), {
                // title: this.$t('toastification.success'),
                variant: 'danger',
                solid: true,
              });

            });
        this.$store.commit('SET_IS_LOADING', false)
        }else{
        this.$nextTick(() => {
        const el = document.querySelector(".is-invalid:first-of-type");
        
        el.scrollIntoView({ behavior: 'instant', block: 'center' });
        // el.scrollIntoView();
        return;
        })
      }
    },
    setCreateAutomaticRecallNumber(event){
      this.createAutomaticRecallNumber = event;
    }
  },
};
</script>